import { render } from "./TeachingPlanCell.vue?vue&type=template&id=f20ddcc4&scoped=true&ts=true"
import script from "./TeachingPlanCell.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanCell.vue?vue&type=script&lang=ts"

import "./TeachingPlanCell.vue?vue&type=style&index=0&id=f20ddcc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20ddcc4"]])

export default __exports__